export interface ImageSpec {
  label: string;
  source: string;
  output: string;
  formats: string;
  maxFileSize: string;
  cdnPath: string;
}

export const imageSpecs = {
  userProfile: {
    label: 'User profile image',
    source: 'Minimum 512 x 512 px square',
    output: '256 x 256, 128 x 128, 64 x 64',
    formats: 'PNG, JPG, or WebP',
    maxFileSize: '5 MB',
    cdnPath: 'cdn/nearrme/{env}/users/{userProfileId}/profile/',
  },
  companyLogo: {
    label: 'Company logo',
    source: 'Minimum 1024 x 1024 px square or transparent logo',
    output: '512 x 512, 256 x 256, 128 x 128, 64 x 64',
    formats: 'PNG, SVG, JPG, or WebP',
    maxFileSize: '10 MB',
    cdnPath: 'cdn/nearrme/{env}/companies/{companyCode}/logo/',
  },
  brandLogo: {
    label: 'Brand logo',
    source: 'Minimum 1024 x 512 px, transparent preferred',
    output: '1024 x 512, 512 x 256, 256 x 128',
    formats: 'PNG, SVG, JPG, or WebP',
    maxFileSize: '10 MB',
    cdnPath: 'cdn/nearrme/{env}/companies/{companyCode}/brands/{brandId}/logo/',
  },
  productImage: {
    label: 'Product image',
    source: 'Minimum 1600 x 1600 px square product photo',
    output: '1200 x 1200, 800 x 800, 400 x 400, 160 x 160',
    formats: 'PNG, JPG, or WebP',
    maxFileSize: '15 MB',
    cdnPath: 'cdn/nearrme/{env}/companies/{companyCode}/products/{productId}/',
  },
  dealImage: {
    label: 'Deal image',
    source: 'Minimum 1600 x 900 px landscape',
    output: '1600 x 900, 1200 x 675, 800 x 450, 400 x 225',
    formats: 'PNG, JPG, or WebP',
    maxFileSize: '15 MB',
    cdnPath: 'cdn/nearrme/{env}/companies/{companyCode}/deals/{dealId}/',
  },
} satisfies Record<string, ImageSpec>;

export function ImageRequirementNote({ spec }: { spec: ImageSpec }) {
  return (
    <div className="mt-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-400">
      <div className="font-semibold text-slate-700 dark:text-slate-300">{spec.label} requirements</div>
      <div className="mt-1">Upload: {spec.source}. Output: {spec.output}.</div>
      <div className="mt-1">Accepted: {spec.formats}. Max file: {spec.maxFileSize}.</div>
      <div className="mt-1 font-mono text-[11px]">{spec.cdnPath}</div>
    </div>
  );
}
